'use client';

import { Button } from '@ahafood/ui/components/button';
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from '@ahafood/ui/components/dialog';
import { useState } from 'react';
import { useNewAuth } from '@/providers/new-auth-provider';

interface NewLoginDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  location?: string;
  redirectTo?: string;
}

export function NewLoginDialog({
  open,
  onOpenChange,
  redirectTo,
}: NewLoginDialogProps) {
  const { login } = useNewAuth();
  const [busy, setBusy] = useState(false);

  const handleLogin = () => {
    if (busy) return;
    setBusy(true);
    void login(redirectTo);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {/* Centered modal on every screen so the bottom navigation never covers it */}
      <DialogContent className="w-[calc(100vw-2rem)] max-w-sm rounded-2xl p-6">
        <DialogTitle className="sr-only">Đăng nhập</DialogTitle>
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-1">
            <h2 className="text-lg font-bold text-neutral-90">
              Bạn cần đăng nhập để tiếp tục
            </h2>
            {/* <p className="text-sm text-neutral-60">
              Đăng nhập bằng tài khoản Ahamove để tiếp tục.
            </p> */}
          </div>
          <Button
            onClick={handleLogin}
            disabled={busy}
            className="h-12 w-full rounded-xl font-bold text-white"
          >
            {busy ? 'Đang chuyển hướng...' : 'Đăng nhập'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
